import { Box, Card, CardContent, Grid, Skeleton, Typography } from "@mui/material"
import MainCard from "../../ui_utils"

const UserTypeShimmerWithoutAvatar = ({ shimmerCount, body }) => {
    shimmerCount = shimmerCount ?? [1, 3, 5]
    return (
        <>
            <Grid container spacing={10} sx={{ paddingTop: 5 }}>
                <Grid item xs sm md>
                    <Box sx={{ margin: 2 }}>
                        <Card raised sx={{ borderRadius: 3 }}>
                            <CardContent>
                                <Grid container columns={6} rowSpacing={3} columnSpacing={3}>
                                    {
                                        shimmerCount.map((index) => (
                                            <Grid item xs={6} sm={3} md={2} key={index} >
                                                <MainCard >
                                                    <Card>
                                                        <Grid container column={6} spacing={1} sx={{ p: 2, alignItems: 'center' }}>
                                                            <Grid item xs md >
                                                                <Grid container direction={"column"} sx={{ pl: 1 }}>
                                                                    <Grid item sx={{ mb: 1 }}>
                                                                        <Typography variant="h4" ><Skeleton animation="wave" variant="rectangle" width={200} height={20} /></Typography>
                                                                    </Grid>
                                                                    {body && <Grid item sx={{ mb: 2 }}>
                                                                        <Typography variant="body1" gutterBottom sx={{ color: 'text.secondary' }}><Skeleton animation="wave" variant="rectangle" width={50} height={10} /></Typography>
                                                                    </Grid>}
                                                                    <Grid item>
                                                                        <Typography variant="subtitle1" sx={{ mt: 2 }} gutterBottom><Skeleton animation="wave" variant="rectangle" width={200} height={20} /></Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item>
                                                                <Skeleton animation="wave" variant="rounded" width={70} height={20} /></Grid>
                                                        </Grid>
                                                    </Card>
                                                </MainCard>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>
            </Grid>

        </>
    )
}

export default UserTypeShimmerWithoutAvatar